import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../../..";
import { CustomAction } from "../../customAction";
import { API_GET_UPDATE_DWELLING_DETAILS_FORM_FIELDS_JSON, API_GET_UPDATE_SAFETY_SECURITY_FEATURES_FORM_FIELDS_JSON, API_POST_UPDATE_USAGE_AND_OCCUPANCY, API_POLICY_CHANGE } from "../../../Apis/ApiEndPoints";
import { IFODwellingDetailsUpdateRequestParams, IFOSafetySecurityFeaturesUpdateRequestParams, IFOccupancyAndUsageUpdateRequestParams, IFOFormFieldsResponse } from "../../../models/user/PolicyChange/FOPolicyChange";
import { IPolicyChangeResponse } from "../../../models/user/PolicyChange/PolicyChange";

export const GetFODwellingDetailsFormJson = createAsyncThunk(
  "foPolicyChange/GetFODwellingDetailsFormJson",
  async (_, { dispatch }) => {
    try {
      const response: IFOFormFieldsResponse = await CustomAction(
        Api.get(API_GET_UPDATE_DWELLING_DETAILS_FORM_FIELDS_JSON),
        dispatch,
        "foPolicyChange/GetFODwellingDetailsFormJson"
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const UpdateFODwellingDetails = createAsyncThunk(
  "foPolicyChange/UpdateFODwellingDetails",
  async (requestParams: IFODwellingDetailsUpdateRequestParams, { dispatch }) => {
    const response: IPolicyChangeResponse = await CustomAction(
      Api.post(`${API_POLICY_CHANGE}/updateDwellingDetails`, requestParams),
      dispatch,
      "foPolicyChange/UpdateFODwellingDetails"
    );
    return response;
  }
);

export const GetFOSafetySecurityFeaturesFormJson = createAsyncThunk(
  "foPolicyChange/GetFOSafetySecurityFeaturesFormJson",
  async (_, { dispatch }) => {
    try {
      const response: IFOFormFieldsResponse = await CustomAction(
        Api.get(API_GET_UPDATE_SAFETY_SECURITY_FEATURES_FORM_FIELDS_JSON),
        dispatch,
        "foPolicyChange/GetFOSafetySecurityFeaturesFormJson"
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const UpdateFOSafetySecurityFeatures = createAsyncThunk(
  "foPolicyChange/UpdateFOSafetySecurityFeatures",
  async (requestParams: IFOSafetySecurityFeaturesUpdateRequestParams, { dispatch }) => {
    const response: IPolicyChangeResponse = await CustomAction(
      Api.post(`${API_POLICY_CHANGE}/updateSafetySecurityFeatures`, requestParams),
      dispatch,
      "foPolicyChange/UpdateFOSafetySecurityFeatures"
    );
    return response;
  }
);

export const GetFOUsageAndOccupancyFormJson = createAsyncThunk(
  "foPolicyChange/GetFOUsageAndOccupancyFormJson",
  async (_, { dispatch }) => {
    try {
      const response: IFOFormFieldsResponse = await CustomAction(
        Api.get(API_POST_UPDATE_USAGE_AND_OCCUPANCY),
        dispatch,
        "foPolicyChange/GetFOUsageAndOccupancyFormJson"
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const UpdateFOUsageAndOccupancy = createAsyncThunk(
  "foPolicyChange/UpdateFOUsageAndOccupancy",
  async (requestParams: IFOccupancyAndUsageUpdateRequestParams, { dispatch }) => {
    const response: IPolicyChangeResponse = await CustomAction(
      Api.post(`${API_POLICY_CHANGE}/updateOccupancyAndUsage`, requestParams),
      dispatch,
      "foPolicyChange/UpdateFOUsageAndOccupancy"
    );
    return response;
  }
); 